import i18n from '../../locales/index'
import axios from 'axios'
import { Spin } from 'view-design'
import restful from '@/store/vuex'

const state = {
  ...restful.states('rebate_order_record')
}

const getters = {
  ...restful.getters('rebate_order_record')
}

const actions = {
  ...restful.actions('rebate_order_records'),
  async get_info ({ commit }, params) {
    Spin.show()
    const res = await axios.get('rebate_order_records', { params })
    commit('setRecords', res.data)
    Spin.hide()
    return res
  }
}

const mutations = {
  ...restful.mutations('rebate_order_record')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
